// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p[data-v-cbf66720]{margin-bottom:2rem}h2[data-v-cbf66720]{font-size:3rem}h2[data-v-cbf66720],h3[data-v-cbf66720]{font-weight:500}h3[data-v-cbf66720]{font-size:2rem}h4[data-v-cbf66720]{font-size:1.5rem;font-weight:500}@media only screen and (max-width:768px){h2[data-v-cbf66720]{font-size:2rem}h3[data-v-cbf66720]{font-size:1.5rem}h4[data-v-cbf66720]{font-size:1.3rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
